const ROUTE_PATHS = {
  SETTINGS: '/settings',
  DASHBOARD: '/dashboard',
  TELEKARDIA_DASHBOARD: '/telekardia/dashboard',
  TELEKARDIA_APPOINTMENTS: '/telekardia/appointments',
  TELEKARDIA_ALL_APPOINTMENT: '/telekardia/all-appointments',
  TELEKARDIA_ADMIN_DASHBOARD: '/admin/dashboard',
  TELEKARDIA_ADMIN_FEEDBACKS: '/admin/feedbacks',
  TELEKARDIA_ADMIN_CONSULTATIONS: '/admin/consultations',
  TELEKARDIA_ADMIN_CALENDAR: '/admin/calendar',
  /* report paths */
  EXPORTS: '/exports',
  REPORTS: '/reports',

  /* patient paths */
  // PATIENTS_DIRECTORY: '/patients/directory',
  PATIENTS_PATIENT_FILE: '/patients/patient-file',
  PATIENTS_ADD_NEW_PATIENT: '/patients/add-new-patient',
  PATIENTS: '/patients',
  SEARCH: '/search',
  PATIENTS_SEARCH_HOME: '/patients/search',

  /* ecg paths */
  EKG_REVIEW_EKG_RECORDING: '/ekg-review/recordings/ekg',
  EKG_REVIEW: '/ekg-review',
  QT_EKG_REVIEW: '/qt-ekg-review',
  EKG_RECORDING: '/ekg-recording/:recordingId',

  // IDTF Routes
  IDTF_KARDIA_RX: '/idtf/kardia-rx',
  PATIENT_ENROLLMENT: '/patient/enroll-patient',

  // CCT-IDTF
  EKG_REVIEW_EKG_ANNOTATION: '/cct/annotator',
  CCT_WORK_LIST: '/cct/work-list',
  CCT_PATIENTS_LIST: '/cct/patients-list',
};
export default ROUTE_PATHS;



// WEBPACK FOOTER //
// ./src/routes/routePaths.js